@if (currentEmployerTableData.length) {
  <app-basic-table
  [tableKeys]="currentEmployerTableKeys"
  [dataset]="currentEmployerTableData"
>
</app-basic-table>
<button mat-flat-button color="primary" (click)="addEmployer()" class="mt-5">Nuovo Datore</button>
}
@else {
  <div>
    <h6 class="m-0">Nessun datore di lavoro presente.</h6>
    <br>
    <h6 class="m-0">Cliccare il tasto "Aggiungi" per inserire un nuovo datore di lavoro.</h6>
    <br>
    <button mat-flat-button color="primary" (click)="addEmployer()">Aggiungi</button>
  </div>
}

